export const initialState = {
  // Management Action Bar Visibility
  showManagementActionBar: false,
  showFilters: false,
};
